<div class="row p-md-3 pt-3 document-case-container">
    <div [class]="(sidebarSection() && orderSelection.showOrderProcess()) ? 'col-lg-2 col-md-12' : 'col-lg-7'">
        @for (row of sectionsRows(); track $index; let rowIndex = $index) {
            @if (row.length > 0) {
                @if (row[0].section_type === 'title') {
                    <h1 class="text-center">
                        {{row[0].content.replace(/\$\w+/g, '')}}
                    </h1>
                } @else {
                    @for (item of row; track $index; let itemIndex = $index) {
                        @if (item.section_type === 'faq') {
                            <div [class]="'col-md-'+(12/row.length)" class="faq-container my-3">
                                <div class="faq-header mb-4 text-center text-md-start">
                                    <span class="faq-badge badge px-3 py-2 rounded-pill mb-2">FAQ</span>
                                    <h2 class="faq-section-title fw-bold mb-2">
                                        {{ item.title || 'Frequently Asked Questions' }}
                                    </h2>
                                    @if (item.subtitle) {
                                        <p class="faq-section-subtitle text-muted">{{ item.subtitle }}</p>
                                    }
                                </div>
                                <div class="accordion custom-faq-accordion" [id]="'faqAccordion-mo-' + rowIndex + '-' + itemIndex">
                                    @for (faq of parseFaq(item.content); track $index; let faqIndex = $index) {
                                        <div class="accordion-item mb-3 border rounded-3 shadow-sm overflow-hidden">
                                            <h2 class="accordion-header" [id]="'heading-mo-' + rowIndex + '-' + itemIndex + '-' + faqIndex">
                                                <button 
                                                    class="accordion-button fw-semibold py-3 px-4" 
                                                    [class.collapsed]="faqIndex !== 0"
                                                    type="button" 
                                                    data-bs-toggle="collapse" 
                                                    [attr.data-bs-target]="'#collapse-mo-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                                    [attr.aria-expanded]="faqIndex === 0 ? 'true' : 'false'" 
                                                    [attr.aria-controls]="'collapse-mo-' + rowIndex + '-' + itemIndex + '-' + faqIndex">
                                                    <span class="faq-question-text">{{ faq.question }}</span>
                                                </button>
                                            </h2>
                                            <div 
                                                [id]="'collapse-mo-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                                class="accordion-collapse collapse" 
                                                [class.show]="faqIndex === 0"
                                                [attr.aria-labelledby]="'heading-mo-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                                [attr.data-bs-parent]="'#faqAccordion-mo-' + rowIndex + '-' + itemIndex">
                                                <div class="accordion-body p-4 bg-white text-secondary">
                                                    <div [innerHTML]="faq.answers || faq.answer" class="dynamic-content-col"></div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        } @else if (item.section_type !== 'sidebar') {
                            @for (segment of sortTheMail(item.content); track $index) {
                                @if (segment.componentToBootUp) {
                                    <ng-container [ngComponentOutlet]="segment.componentToBootUp">
                                    </ng-container>
                                } @else {
                                    <div [innerHTML]="segment.html"></div>
                                }
                            }
                        }
                    }
                }
            }
        }
    </div>

    @if (sidebarSection()) {
        <div [class]="(sidebarSection() && orderSelection.showOrderProcess()) ? 'col-md-5' : 'col-lg-5'">
            <div class="sidebar-section-card p-4 rounded-4 shadow-sm bg-white border border-light-subtle mb-4">
                <div class="sidebar-header mb-3">
                    <span class="sidebar-badge badge px-3 py-2 rounded-pill mb-2 bg-primary-subtle text-primary fw-bold">Information</span>
                    @if (sidebarSection()?.title) {
                        <h3 class="sidebar-title fw-bold text-dark mb-1">
                            {{ sidebarSection()?.title }}
                        </h3>
                    }
                    @if (sidebarSection()?.subtitle) {
                        <p class="sidebar-subtitle text-muted small mb-0">
                            {{ sidebarSection()?.subtitle }}
                        </p>
                    }
                </div>
                <div [innerHTML]="sidebarSection()?.content" class="sidebar-body dynamic-content-col"></div>
            </div>
        </div>
    }

    @if (orderSelection.showOrderProcess()) {
        <div [class]="(sidebarSection() && orderSelection.showOrderProcess()) ? 'col-md-5 order-process' : 'col-lg-5 order-process'">


        @if (!orderSelection.startWithCount()) {
        <div class="question-div slideOutLeft text-center" [class.anim-slide-out-right]="isExiting">
            <span class="total-qst">How many documents do you have?</span>
            <select name="caseCount" class="form-select d-inline-block border-dark ms-2" style="max-width: 75px;"
                id="count" (change)="onCountChange($event)">
                @for (item of items; track $index) {
                <option [value]="item">{{ item }}</option>
                }
            </select>
            <span class="pls-select"></span>
        </div>
        }

        @if (orderSelection.startWithCount()) {
        <div class="mb-3 text-start">
            <button class="btn btn-outline-secondary btn-sm" (click)="orderSelection.showOrderProcess.set(false)">
                &larr; Back to document list
            </button>
        </div>
        <div class="case-service t m-auto" style="max-width: 800px;">
            <input type="hidden" id="serviceData" value="[]">

            @if (orderSelection.documentPrices()) {
            <div class="table-responsive d-block">
                <table class="table table-bordered table-striped doctyp-tbl">
                    <thead>
                        <tr>
                            <th>Service requested</th>
                            <th>Fee</th>
                            <th>Count</th>
                            <th>Total Fee</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody class="modal-service-table-body">
                        @for (service of orderSelection.documentPrices()!.services; track service.Id) {
                        <tr>
                            <td>{{ service.Name }}</td>
                            <td>${{ service.Fee }}</td>
                            <td>{{ service.Count }}</td>
                            <td>${{ service.TotalFee }}</td>
                            <td>{{ service.Time }} business days</td>
                        </tr>
                        }
                        @if (orderSelection.extraPages() > 0) {
                        <tr>
                            <td>Additional Pages Fee (> 10 pages)</td>
                            <td>$0.25</td>
                            <td>{{ orderSelection.extraPages() }}</td>
                            <td>${{ (orderSelection.extraPages() * 0.25).toFixed(2) }}</td>
                            <td>-</td>
                        </tr>
                        }
                        <tr class="fw-bold">
                            <td>Total</td>
                            <td></td>
                            <td></td>
                            <td>${{ (orderSelection.documentPrices()!.TotalFee + (orderSelection.extraPages() * 0.25)).toFixed(2) }}</td>
                            <td>{{ orderSelection.documentPrices()!.TotalTime }} business days</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            }
            <div>
                <p class="text-center w-100 mb-2">
                    Please choose your document type:
                </p>
                <div class="fee d-flex flex-wrap justify-content-between">
                    @if (orderSelection.highestRestrictionLevel() === 1 || orderSelection.highestRestrictionLevel() === 2) {
                        @if (!hasRegularOrder) {
                            <a class="btn btn-success form-control showDigital" role="button" (click)="onDigitalDocument()">
                                I have <br> a digital <br> document
                            </a>
                        }
                        @if(!showDigitalUpload()){
                            <a class="btn btn-primary form-control text-center" (click)="onHardCopy()">
                                <span>
                                    I have <br> a hard copy <br> document
                                </span>
                            </a>
                        }
                    } @else if (orderSelection.highestRestrictionLevel() === 3) {
                    <a class="btn btn-primary form-control text-center" (click)="onProceed()">
                        <span>
                            Proceed
                        </span>
                    </a>
                    }
                    @if((showDigitalUpload() || orderSelection.highestRestrictionLevel() === 3) && orderSelection.date()){
                        <div class="text-center ">
                            <small>Expected to be shipped on</small>
                            <div class="date dateCard" style="width: 110px">
                                <p class="day mb-1">{{ orderSelection.date() | date:'EEE' }}</p>
                                <p class="num mb-1" style="font-weight: 700;font-size: 3rem;line-height: 1;">{{ orderSelection.date() | date:'d' }}</p>
                                <p class="month m-0">{{ orderSelection.date() | date:'MMM' }}</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <app-upload-box [style.display]="showDigitalUpload() ? 'block' : 'none'" [docCount]="orderSelection.totalDocCount() + extraUploadFilesCount()" [customHeadings]="uploadHeadings()" [featuredImage]="featuredImage()" (uploadsCompleted)="onUploadsCompleted($event)" (proceedWithHardCopy)="onHardCopy()"></app-upload-box>
        </div>
        }
    </div>
    }
</div>

<!-- Case 2 Confirmation Modal -->
<div class="modal fade" [class.show]="orderSelection.showCase2Modal()"
    [style.display]="orderSelection.showCase2Modal() ? 'block' : 'none'" tabindex="-1" aria-labelledby="case2ModalLabel"
    aria-hidden="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="case2ModalLabel">Important Confirmation</h5>
                <button type="button" class="btn-close" (click)="orderSelection.showCase2Modal.set(false)"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-start">
                <p>The document(s) you have selected are accepted as digital, <br> but a <strong>Physical Notary
                        Public</strong> is required.</p>
                <p>Please confirm that you understand this requirement before proceeding.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary"
                    (click)="orderSelection.showCase2Modal.set(false)">Cancel</button>
                <!-- This button triggers the order process start and closes the modal -->
                <button type="button" class="btn btn-primary"
                    (click)="orderSelection.startOrder(); orderSelection.showCase2Modal.set(false)">Confirm and
                    Proceed</button>
            </div>
        </div>
    </div>
</div>

<!-- FDA Digital Modal -->
<div class="modal fade" [class.show]="showFdaDigitalModal()"
    [style.display]="showFdaDigitalModal() ? 'block' : 'none'" tabindex="-1" aria-labelledby="fdaDigitalModalLabel"
    aria-hidden="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 750px;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="fdaDigitalModalLabel">Digital FDA Signature Required</h5>
                <button type="button" class="btn-close" (click)="showFdaDigitalModal.set(false)"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-start">
                <p>
                    Please note that all Certificates of Pharmaceutical Product now require a digital FDA signature. <br>
                    Certificates without the FDA digital signature are being rejected by the U.S. Department of State.
                </p>
            </div>
            <div class="modal-footer d-flex flex-column gap-2">
                <button type="button" class="btn btn-primary w-100"
                    (click)="onFdaDigitalOneFile()">
                    I received "one digital file".
                </button>
                <button type="button" class="btn btn-secondary w-100"
                    (click)="onFdaDigitalTwoFiles()">
                    The first page came in a file, the attachment came in a separate file. Total of 2 files for one single document.
                </button>
            </div>
        </div>
    </div>
</div>

@if (orderSelection.showCase2Modal() || showFdaDigitalModal()) {
<div class="modal-backdrop fade show"></div>
}